// extracted by mini-css-extract-plugin
module.exports = {"container":"addCard_container_2FIx3","content":"addCard_content_1FSZL"};